
const HomeFooter = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 py-10">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center mb-6 md:mb-0">
            <img 
              src="/lovable-uploads/39686db0-4967-4556-a4f9-65cbf5776672.png" 
              alt="SunJob Technology" 
              className="h-10 w-auto mr-3" 
            />
          </div>
          <div className="text-sm">
            © {new Date().getFullYear()} SunJob Technology. Todos os direitos reservados.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default HomeFooter;
